import { render } from "./googleAuthorize.vue?vue&type=template&id=16965a7c&scoped=true&ts=true"
import script from "./googleAuthorize.vue?vue&type=script&lang=ts"
export * from "./googleAuthorize.vue?vue&type=script&lang=ts"

import "./googleAuthorize.vue?vue&type=style&index=0&id=16965a7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16965a7c"]])

export default __exports__